import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TiimePipesModule } from 'tiime-expert-utils';
import { TiimeIconModule, TiimeTooltipModule } from 'tiime-material';

import { DocumentCategoryIdentifierIconComponent } from './document-category-identifier-icon.component';

@NgModule({
  declarations: [DocumentCategoryIdentifierIconComponent],
  imports: [CommonModule, TiimeTooltipModule, TiimePipesModule, TiimeIconModule],
  exports: [DocumentCategoryIdentifierIconComponent]
})
export class DocumentCategoryIdentifierIconModule {}
